import { Transform } from 'class-transformer';
import {
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsPositive,
  Max,
  IsString,
  IsUUID,
} from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';

/** The largest value the integer column can store. */
export const MAX_VALIDITY_HOURS = 2_147_483_647;

export interface ConsentRevisionDto extends BaseDto {
  consentId: string;
  description: string;
  /** Hours a given consent stays valid; null or absent means it never expires. */
  validityHours?: number | null;
  // Holds the long version of the text of the consent revision.
  longText: string;
  name: string;
}

export class CreateConsentRevisionDto
  extends BaseCreateDto
  implements Partial<ConsentRevisionDto>
{
  @IsNotEmpty()
  @IsUUID()
  consentId: string;

  @IsNotEmpty()
  @IsString()
  description: string;

  @IsNotEmpty()
  @IsString()
  longText: string;

  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  // Only strings: implicit conversion would also turn `true` into 1 hour.
  @Transform(({ value }) =>
    typeof value === 'string' && value !== '' ? Number(value) : value,
  )
  @IsInt()
  @IsPositive()
  @Max(MAX_VALIDITY_HOURS)
  validityHours?: number | null;
}
